type CheckboxProps = {
  value: boolean
  onValueChange: (value: boolean) => void
  disabled?: boolean
}

export function Checkbox({ value, onValueChange, disabled }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      checked={value}
      disabled={disabled}
      onChange={(event) => onValueChange(event.target.checked)}
    />
  )
}
